import { render, staticRenderFns } from "./SideNavDivider.vue?vue&type=template&id=66b0ded8&scoped=true&"
import script from "./SideNavDivider.vue?vue&type=script&lang=js&"
export * from "./SideNavDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0ded8",
  null
  
)

export default component.exports